module.exports = __webpack_public_path__ + "static/img/QLD-20.7c1197e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-20.jpg
// module id = 6tOb
// module chunks = 0